export default __webpack_public_path__ + "static/media/read_write2.d3b10890.png";